import React from 'react';
import "./SectorList.css";
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const SectorList = (
    {
        onUpdateIdsSectorCheckBoxSelected,
        idsSectorCheckBoxSelected,
        sectorsLoadedFilter
    }) => {

    return (
        <>
            <PanelListDefault
                onUpdateIdSelected={onUpdateIdsSectorCheckBoxSelected}
                idsSelected={idsSectorCheckBoxSelected}
                data={sectorsLoadedFilter} />
        </>
    )
}
export default SectorList;